import { ProductlistPageBrandContent } from 'models/ProductlistPageBrandContent';
import { Section } from 'components/Section';
import { Grid, Cell } from 'components/Grid';
import { CategoryLink } from 'components/Shared/CategoryLink';
import { rm, hasElements, NO_ELEMENT } from 'utils';
import styles from './popularCategories.scss';
import connect from 'components/Shared/connect';
import { isDesktopLayout, isTablet } from 'components/Shared/responsive';
import { HeaderState } from 'models/HeaderState';

type OwnProps = Pick<ProductlistPageBrandContent, 'brandName' | 'popularCategories'>;
interface MergedProps extends OwnProps {
  categoryAppearanceType: 'primary' | 'secondary' | 'tertiary';
}

const _PopularCategories = ({
  brandName,
  popularCategories,
  categoryAppearanceType
}: MergedProps) => {
  const title = rm('brand_brandpage_popularcategories', brandName);

  if (!hasElements(popularCategories)) {
    return NO_ELEMENT;
  }
  return (
    <Section title={title}>
      <Grid
        className={styles.popularCategoriesGrid}
        gutters="extraLarge"
        huge="5"
        large="4"
        tablet="3"
      >
        {popularCategories.map((item, i) => (
          <Cell className={styles.popularCategoriesCell} key={item.url + i.toString()}>
            <CategoryLink
              appearance={categoryAppearanceType}
              categoryUrl={item.url}
              image={item.image}
            >
              <h4 className={styles.categoryTitle}>{item.title}</h4>
              <p className={styles.categoryDescription}>{item.description}</p>
            </CategoryLink>
          </Cell>
        ))}
      </Grid>
    </Section>
  );
};

const getCategoryAppearance = (state: Pick<HeaderState, 'currentBreakpoint'>) => {
  if (isDesktopLayout(state)) {
    return 'primary';
  }

  if (isTablet(state)) {
    return 'secondary';
  }

  return 'tertiary';
};

export const PopularCategories = connect<MergedProps, OwnProps>(state => ({
  categoryAppearanceType: getCategoryAppearance(state)
}))(_PopularCategories);
